export default __webpack_public_path__ + "static/media/00-principal.d040e82e.jpg";